import {
  Button,
  Link as MaterialLink,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  Container,
  makeStyles,
  createStyles,
  Theme,
} from "@material-ui/core";
import React, { FormEvent, useEffect, useState } from "react";
import { IEstadoCivil, IMunicipio, IUser } from "./interfaces";
import { getEstadosCiviles, getMunicipios, signin } from "./functions";
import swal from "sweetalert";
import { useHistory, Link } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import { Facebook, Twitter, YouTube } from "@material-ui/icons";
import Axios from "axios";
import { AXIOS_OPTIONS, MAIN_API } from "../../utils/constants";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    vector: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        marginTop: 100,
        display: "flex",
        justifyContent: "center",
      },
    },
  })
);

const SignIn = () => {
  const classes = useStyles();
  const history = useHistory();
  const [error, setError] = useState(false);
  const [municipios, setMunicipios] = useState<Array<IMunicipio>>([]);
  const [estadosCiviles, setEstadosCiviles] = useState<Array<IEstadoCivil>>([]);
  const [recaptcha, setRecaptcha] = useState("");
  const [formData, setFormData] = useState<IUser>({
    username: "",
    password: "",
    idGenero: 0,
    idMunicipio: 0,
    idEstadoCivil: 0,
    nombre: "",
    paterno: "",
    materno: "",
    fechaNacimiento: "",
    curp: "",
    rfc: "",
    telefono: "",
    noCuenta: "",
    email: "",
    colonia: "",
    calle: "",
    codigoPostal: "",
    noCasa: "",
  });
  const [saving, setSaving] = useState(false);

  const fetchData = async () => {
    setMunicipios(await getMunicipios());
    setEstadosCiviles(await getEstadosCiviles());
  };

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setSaving(true);
    // Recaptcha validation
    const recaptchaResponse = await Axios.post(
      `${MAIN_API}/validate-recaptcha`,
      {
        response: recaptcha,
      },
      AXIOS_OPTIONS
    );
    if (!recaptchaResponse.data.success) {
      return Swal.fire(
        "Error de reCAPTCHA",
        "La prueba de reCAPTCHA no fue superada",
        "error"
      );
    }

    // Ends recaptcha validation

    if (
      !formData.email ||
      !formData.username ||
      !formData.password ||
      !formData.nombre ||
      !formData.paterno ||
      !formData.curp ||
      !formData.rfc ||
      !formData.noCuenta ||
      !formData.telefono ||
      !formData.fechaNacimiento ||
      !formData.idEstadoCivil
    ) {
      setError(true);
      return;
    }
    if (await signin(formData)) {
      swal({
        title: "Usuario registrado correctamente",
        text: "Será redirigido a la página de inicio de sesión",
        icon: "success",
      }).then(() => history.push("/login"));
    }
    setSaving(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <React.Fragment>
      <Container maxWidth="xl">
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} style={{ marginTop: 30 }}>
            <img
              style={{ width: 150 }}
              src={require("./../../assets/images/isset-logo.png")}
              alt="Logo ISSET"
            />
            <div style={{ marginTop: 100 }}>
              <Typography
                color="primary"
                component="p"
                variant="h4"
                style={{ fontWeight: 500 }}
              >
                Bienvenido
              </Typography>
              <Typography style={{ marginTop: 30 }}>
                Por favor registre los datos que se solicitan para tener acceso
                a los sistemas del Instituto de Seguridad Social del Estado de
                Tabasco.
              </Typography>
              <div className={classes.vector}>
                <img
                  src={require("./../../assets/images/signin/access-account.svg")}
                  alt="Access Account"
                  style={{ maxWidth: 450 }}
                />
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={6} style={{ marginTop: 30 }}>
            <Typography component="h1" variant="h3">
              Crear cuenta
            </Typography>
            <form style={{ marginTop: 40 }} onSubmit={submit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    component="p"
                    color="primary"
                    style={{ fontWeight: 500 }}
                  >
                    Datos de la cuenta:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Correo electrónico"
                    type="email"
                    value={formData?.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={error && !formData.email}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Nombre de usuario"
                    value={formData?.username}
                    onChange={(e) =>
                      setFormData({ ...formData, username: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={error && !formData.username}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Contraseña"
                    type="password"
                    value={formData?.password}
                    onChange={(e) =>
                      setFormData({ ...formData, password: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    helperText="Conserve su contraseña en un lugar seguro"
                    error={error && !formData.password}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="h5"
                    component="p"
                    color="primary"
                    style={{ fontWeight: 500 }}
                  >
                    Datos personales:
                  </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Nombre"
                    value={formData?.nombre}
                    onChange={(e) =>
                      setFormData({ ...formData, nombre: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={error && !formData.nombre}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Apellido paterno"
                    value={formData?.paterno}
                    onChange={(e) =>
                      setFormData({ ...formData, paterno: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={error && !formData.paterno}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Apellido materno"
                    value={formData?.materno}
                    onChange={(e) =>
                      setFormData({ ...formData, materno: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <FormControl
                    error={error && !formData.idGenero}
                    component="fieldset"
                    fullWidth
                    required
                  >
                    <FormLabel>Género</FormLabel>
                    <RadioGroup
                      value={formData.idGenero}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          idGenero: Number(e.target.value),
                        })
                      }
                      style={{ display: "inline" }}
                    >
                      <FormControlLabel
                        value={1}
                        label="Masculino"
                        control={<Radio color="primary" />}
                      />
                      <FormControlLabel
                        value={2}
                        label="Femenino"
                        control={<Radio color="primary" />}
                      />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="CURP"
                    value={formData?.curp}
                    onChange={(e) =>
                      setFormData({ ...formData, curp: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    inputProps={{
                      minLength: 18,
                      maxLength: 18,
                    }}
                    error={error && !formData.curp}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="RFC"
                    value={formData?.rfc}
                    onChange={(e) =>
                      setFormData({ ...formData, rfc: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    inputProps={{
                      minLength: 13,
                      maxLength: 13,
                    }}
                    error={error && !formData.rfc}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Número de cuenta ISSET"
                    type="number"
                    value={formData?.noCuenta}
                    onChange={(e) =>
                      setFormData({ ...formData, noCuenta: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    required
                    fullWidth
                    error={error && !formData.noCuenta}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Teléfono"
                    type="tel"
                    value={formData?.telefono}
                    onChange={(e) =>
                      setFormData({ ...formData, telefono: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    inputProps={{
                      minLength: 10,
                      maxLength: 15,
                    }}
                    error={error && !formData.telefono}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Fecha de nacimiento"
                    value={formData?.fechaNacimiento}
                    type="date"
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        fechaNacimiento: e.target.value,
                      })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                    error={error && !formData.fechaNacimiento}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Estado civil"
                    select
                    value={formData?.idEstadoCivil}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        idEstadoCivil: Number(e.target.value),
                      })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                    required
                    error={error && !formData.idEstadoCivil}
                  >
                    <MenuItem value={0}>Seleccione su estado civil</MenuItem>
                    {estadosCiviles.map((estadoCivil) => (
                      <MenuItem
                        key={estadoCivil.idEstadoCivil}
                        value={estadoCivil.idEstadoCivil}
                      >
                        {estadoCivil.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Municipio"
                    select
                    value={formData?.idMunicipio}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        idMunicipio: Number(e.target.value),
                      })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  >
                    <MenuItem value={0}>Seleccione un municipio</MenuItem>
                    {municipios.map((municipio) => (
                      <MenuItem
                        key={municipio.idMunicipio}
                        value={municipio.idMunicipio}
                      >
                        {municipio.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Código postal"
                    type="number"
                    value={formData?.codigoPostal}
                    onChange={(e) =>
                      setFormData({ ...formData, codigoPostal: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Colonia"
                    value={formData?.colonia}
                    onChange={(e) =>
                      setFormData({ ...formData, colonia: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Calle"
                    value={formData?.calle}
                    onChange={(e) =>
                      setFormData({ ...formData, calle: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    label="Número de casa"
                    type="number"
                    value={formData?.noCasa}
                    onChange={(e) =>
                      setFormData({ ...formData, noCasa: e.target.value })
                    }
                    variant="outlined"
                    margin="dense"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12}>
                  <div
                    style={{
                      marginTop: 15,
                      marginBottom: 15,
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <ReCAPTCHA
                      sitekey="6LfYqckZAAAAANesWPTVjEUoKwQZKSoXlWSaEcj4"
                      onChange={(value) => {
                        if (value) setRecaptcha(value);
                      }}
                      onExpired={() => setRecaptcha("")}
                    />
                  </div>
                  <Button
                    disabled={!recaptcha || saving}
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ width: "100%" }}
                  >
                    {saving ? "Cargando, por favor espere..." : "Registrarme"}
                  </Button>
                  <Typography style={{ marginTop: 15, textAlign: "center" }}>
                    ¿Ya tienes una cuenta?{" "}
                    <MaterialLink component={Link} to="/login">
                      Inicia sesión
                    </MaterialLink>
                  </Typography>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                    style={{ textAlign: "right" }}
                  >
                    * Campos obligatorios
                  </Typography>
                  <Typography>
                    Síguenos en: <br />
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://twitter.com/Isset_Tab"
                    >
                      <Twitter style={{ color: "#00ACEE" }} />
                    </a>
                    <a
                      style={{ marginLeft: 10 }}
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.facebook.com/issetTabasco"
                    >
                      <Facebook style={{ color: "#3B5998" }} />
                    </a>
                    <a
                      style={{ marginLeft: 10 }}
                      rel="noopener noreferrer"
                      target="_blank"
                      href="https://www.youtube.com/channel/UCl6tcQE_bnIRDQz35ASH69Q"
                    >
                      <YouTube style={{ color: "#C4302B" }} />
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
};

export default SignIn;
